"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(_ref) {
  var stroke = _ref.stroke,
      color = _ref.color,
      theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("color:", (0, _util.themeValLookup)(color)({
    theme: theme
  }) || color, ";position:relative;display:inline-flex;text-align:center;svg{margin:-", (0, _util.rem)(stroke * 2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var progressCircle = process.env.NODE_ENV === "production" ? {
  name: "1ree1la",
  styles: "transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%;stroke:currentColor"
} : {
  name: "1tf3udx-progressCircle",
  styles: "transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%;stroke:currentColor;label:progressCircle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var backgroundCircle = function backgroundCircle(theme) {
  return /*#__PURE__*/(0, _react.css)("stroke:", theme.color.monochrome.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:backgroundCircle;"));
};

var step = function step(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);font-weight:", theme.fontWeight.bold, ";font-size:", theme.fontSize.tiny, ";line-height:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:step;"));
};

var styles = {
  base: base,
  progressCircle: progressCircle,
  backgroundCircle: backgroundCircle,
  step: step
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map